<pbc-sorter [config]="ProjektStatiSorterConfig" [sorter]="projektStati.sorter$ | async" (sorterChange)="projektStati.sorter$.next($event)"></pbc-sorter>
